import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
       <div class="col00">
       <div class="heading01 type01">
            <h1>{{ 'user.Terms and Conditions' | translate}}</h1>
       </div>
            <p ng-bind-html="vm.termsAndConditions"></p>
        </div>
    `
})
export default class {
    constructor ($translate) {
        this.termsAndConditions = $translate.instant('user.Coursy terms and conditions');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/conditions/index.js